<template>
  <section class="programmes-container">
    <div class="content-max-width">

        <div class="form-search flex">

          <div class="form-field text search">
            <label>Search all services</label>
            <input type="text"
              placeholder="Start typing..."
              v-model="payload.search"
            >
          </div>

          <div class="form-fields-stack">
            <div class="form-field select">
              <label>Filter by location</label>
              <select v-model="payload.location">
                <option :value="0">All Locations</option>

                <option
                  v-for="location of locations"
                  :value="location.id" :key="location.id"
                >
                  {{ location.title }}
                </option>
              </select>
            </div>

            <div class="form-field">
              <label>&nbsp;</label>
              <button
                class="button grey-border"
                @click="payload.search = ''; payload.location = 0;"
              >
                <span class="icon-clear"></span> Clear filter
              </button>
            </div>
          </div>

        </div>

        <div class="all-results">

          <div class="results flex">
            <a v-for="link of results" :href="link.url" >
              {{ link.title }}
            </a>
          </div>

        </div>

    </div>

  </section>
</template>

<script>
export default {
  props: {
    contracts: Array,
    locations: Array
  },
  data () {
    return {
      payload: {
        search: '',
        location: 0
      }
    };
  },
  computed: {
    results () {
      if (this.payload.location === 0) {
        return this.contracts.filter((obj) => {
          // keyword-search
          return obj.title.toLowerCase().includes(this.payload.search.toLowerCase());
        })
      } else {
        return this.contracts.filter((obj) => {
          // match location, then keyword-search
          if (obj.locations.includes(this.payload.location)) {
            return obj.title.toLowerCase().includes(this.payload.search.toLowerCase());
          }
        })
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/acc-programmes/Index.vue